import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

const RUTAS_SIN_REFRESH = ['/auth/refresh', '/auth/verify-otp', '/auth/send-otp'];

/**
 * Si una petición autenticada falla con 401 (access token expirado/inválido),
 * intenta renovar la sesión con el refresh token (7 días) y reintenta esa
 * misma petición una sola vez. Debe ser el ÚLTIMO interceptor del arreglo en
 * app.config.ts (el más cercano al backend).
 */
export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  if (RUTAS_SIN_REFRESH.some((ruta) => req.url.includes(ruta))) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && auth.isLoggedIn) {
        return auth.refreshAccessToken().pipe(
          switchMap((nuevoToken) =>
            next(req.clone({ setHeaders: { Authorization: `Bearer ${nuevoToken}` } }))
          ),
          catchError(() => throwError(() => error))
        );
      }
      return throwError(() => error);
    })
  );
};
